import React from "react";
import { Tooltip } from "antd";

const DecimalFormatter = (props) => {
  let nFormat;
  let suffix;

  //  function for making no a shorthand
  const numberShortHand = (n, precision) => {
    if (n < 900) {
      return n;
    } else if (n < 900000) {
      // 0.9k-850k
      nFormat = (n / 1000).toFixed(precision);
      suffix = "K";
    } else if (n < 900000000) {
      // 0.9m-850m
      nFormat = (n / 1000000).toFixed(precision);
      suffix = "M";
    } else if (n < 900000000000) {
      // 0.9b-850b
      nFormat = (n / 1000000000).toFixed(precision);
      suffix = "B";
    } else {
      // 0.9t+
      nFormat = (n / 1000000000000).toFixed(precision);
      suffix = "T";
    }

    if (precision === 0) {
      return nFormat;
    } else {
      const dotZero = "." + "0".repeat(precision);
      nFormat = nFormat.replace(dotZero, "");
    }

    return nFormat + suffix;
  };

  // formatting currency amount according to it's country convention

  const formatNumber = (num, country) => {
    let number= num ? Number(num):num;
    if (number === 0 || !number) {
      return country=="TRY" ? "0,00":0;
    }
    switch (country) {
      case "India":
        return number?.toFixed(2)?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        break;

      case "TRY":
        return number
          ?.toFixed(2)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
          .replace(/\.(?=[^.]*$)/, ",");
        break;

      case "PLN":
        return number
          ?.toFixed(2)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
          .replace(".", ",");
        break;

      // case "Qatar":
      //   //return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      //   return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

      //   break;

      case "SAR":
        return number?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        break;

      case "AED":
        return number?.toFixed(2)?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        break;

      case "EGP":
        return number?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        break;

      case "BHD":
        return number?.toFixed(3).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        break;

      case "KZT":
        return number
          ?.toFixed(2)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
          .replace(".", ",");
        break;

      case "OMR":
        return number
        ?.toFixed(3) // Round to three decimal places
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"); // Add commas as thousands separators
    
        break;

      case "JOD":
        return number?.toFixed(3).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        break;

      default:
        return number?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };

  // adding styling to the decimalPart
  const decimalStyle = {
    fontSize: "80%",
  };
  const integerStyle = {
    fontSize: props.fontSize ? props.fontSize : "",
  };
  //  splitting the amount into integerPart and decimalPart
  const splitAmount = (amount,country) => {
    let integerPart=0;
    let decimalPart=0;
    if(amount){
      if (amount === 0) {
        integerPart = 0;
        decimalPart = 0;
      }
      else if (country === "TRY")
       {
          const tryParts = amount?.split(",");
          integerPart = tryParts[0] || "0";
          decimalPart = tryParts[1] || "0";
       }
       else {
        const parts = amount?.split(".");
        integerPart = parts[0] || "0";
        decimalPart = parts[1] || "0";
      }
      return { integerPart, decimalPart };
    }else{
      return { integerPart, decimalPart };
    }
   
  };

 
  //checking whether format is correct or not for every country
  const formattedCurrency = formatNumber(props.amount, props.country);

  // shorthand conversion for given amount
  const isShorthand = numberShortHand(props.amount, 2);

  const { integerPart, decimalPart } = splitAmount(formattedCurrency,props.country);

  // text for tooltip
  const text = <span>{formattedCurrency}</span>;

  return (
    <>
    {
       props.flag && props.amount > 900 ? (
        <Tooltip placement="top" title={text}>
          <span style={{ borderBottom: "1px dashed" }}>
            {isShorthand}
         </span>
        </Tooltip>
       ) : (
      <span>
          {integerPart === 0 ? (
            <span style={integerStyle}>{integerPart}</span>
          ) : (
            <>
            {props.country !== "TRY" ?
             <>
              <span style={integerStyle}>{integerPart}{props?.isShowDecimal && <>.</>}</span>
              {props?.isShowDecimal && <span style={decimalStyle}>{decimalPart}</span>}
            </> 
             :
              <>
                 <span>{integerPart},</span>
                 <span style={decimalStyle}>{decimalPart}</span>
              </>
            }
            </>
          )}
      </span>
           )
     }
    </>
  );
};

export default DecimalFormatter;

// for Turkey - 1.234.567,89  -
// for Poland - 1 234 567,89  
// for Qatar - 1,234,567.89  
// for saudi Arabia - 1,234,567.89  
// for UAE - 1,234,567.89    
// for Egypt - 1,234,567.89   
// for Bahrain - 1,234,567.89  
// for Kazakhstan -1 234 567,89 
// for Oman - 1,234,567,890,   
// for Jordan - 1,234,567.89,  - 


